import React, { useState, useEffect, Fragment } from "react";
import {
  Box,
  Card,
  Stack,
  responsiveFontSizes,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchRecepcion } from "verticales/FetchData";
import Tabs from "@mui/material/Tabs";
import MDBox from "components/MDBox";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CardContent from "@mui/material/CardContent";
import AppLoading from "verticales/AppLoading.tsx";
import { Label } from "recharts";
import { Backpack, FileDownload, Mail, Margin, Padding } from "@mui/icons-material";
import { json } from "react-router-dom";
import fetchData from "verticales/FetchData";
import { check } from "prettier";

const url = "";
const action = "";
function resources(props) {
  const users = props.row.original;
  const access = props.access;
  console.log(users);
  console.log(access);
  const [dataResource, setDataResource] = useState([]);
  // const [checkedActions, setCheckedActions] = useState([]);
  const [blocking, setBlocking] = React.useState(true);

  const infoResource = async () => {
    setDataResource(access);
    setBlocking(false);
  };

  const handleToggle = (action) => {
    const key = `${action}`;
    setCheckedActions((prev) =>
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key]
    );
  };

  useEffect(() => {
    infoResource();
  }, []);

  return (
    <DashboardLayout>
      <MDBox pt={4} pb={3} px={3} display="flex" justifyContent="center">
        <Grid>
          <Card
            sx={{
              width: "100",
              maxWidth: "90vw",
              maxHeight: "90vh",
              boxShadow: 3,
              borderRadius: 3,
            }}
          >
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={5}
              mt={-3}
              p={2}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="bold" color="white" mt={1}>
                Accesos de usuario
              </MDTypography>
            </MDBox>
            {blocking ? (
              <AppLoading titleCustom={"Acciones por recursos"} />
            ) : (
              <Grid
                p={3}
                pl={5}
                pr={5}
                item
                xs={12}
                sm={10}
                md={8}
                lg={6}
                xl={4}
                sx={{
                  width: "40vw",
                  maxWidth: "90vw",
                  maxHeight: "90vh",
                  fontSize: "18px",
                  overflow: "auto",
                }}
              >
                <Grid item xs={12} ml={-2}>
                  <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                    {dataResource.map((access, index) => (
                      <Accordion key={index}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography>{access.resource}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <List dense>
                            {access.acciones.map((action, i) => (
                              <ListItem key={i}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={users?.resources?.some(
                                        (res) =>
                                          res.id === access.idr &&
                                          res.bodyAction?.actions?.includes(action)
                                      )}
                                    />
                                  }
                                  label={action}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </MDBox>
                </Grid>
              </Grid>
            )}
            <Stack justifyContent="flex-end" direction="row" sx={{ p: 2 }}>
              <MDButton variant="contained" color="info" onClick={props.handleCloseModal}>
                Aceptar
              </MDButton>
            </Stack>
          </Card>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default resources;
